"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddressFromRecordWithPrefix = exports.getAddressFromRecord = void 0;
const countries_1 = require("../countries");
const stateCodes_1 = require("../stateCodes");
const address_class_1 = __importDefault(require("./address.class"));
const getAddressFromRecord = (getValue) => {
    var _a;
    const country = countries_1.getCountryCode(getValue("country"));
    if (!country) {
        throw Error("Country not set");
    }
    const address1 = getValue("address1");
    const address2 = getValue("address2");
    const city = getValue("city");
    const stateStr = getValue("state");
    const state = (_a = stateCodes_1.stateCodes.getCode(country, stateStr)) !== null && _a !== void 0 ? _a : stateStr;
    const zipcode = getValue("postal");
    return new address_class_1.default(address1, city, state, zipcode, country, address2);
};
exports.getAddressFromRecord = getAddressFromRecord;
const getAddressFromRecordWithPrefix = (getValue) => (prefix) => {
    var _a;
    const country = countries_1.getCountryCode(getValue(`${prefix}Country`));
    if (!country) {
        throw Error(`${prefix} country not set`);
    }
    const address1 = getValue(`${prefix}Address1`);
    const address2 = getValue(`${prefix}Address2`);
    const city = getValue(`${prefix}City`);
    const stateStr = getValue(`${prefix}State`);
    const state = (_a = stateCodes_1.stateCodes.getCode(country, stateStr)) !== null && _a !== void 0 ? _a : stateStr;
    const zipcode = getValue(`${prefix}Postal`);
    return new address_class_1.default(address1, city, state, zipcode, country, address2);
};
exports.getAddressFromRecordWithPrefix = getAddressFromRecordWithPrefix;
exports.default = address_class_1.default;
//# sourceMappingURL=index.js.map